<template>
    <div class="mb-3">
        <label class="form-label">{{ trans('quality_assurance.configuration.modal.sla.label') }}</label>
        <small class="mb-2 block text-muted">
            {{ trans('quality_assurance.configuration.modal.sla.fanout_hint') }}
        </small>
        <jet-select
            v-model="form.maintainer_service_level_agreement_id"
            :disabled="slaOptions.length === 0 || !canManagePreventativeSchedule"
            :horizontal="false"
            :invalid-feedback="form.errors.maintainer_service_level_agreement_id"
            :options="slaOptions"
            :resettable="true"
        />
        <small v-if="slaOptions.length === 0" class="text-muted">
            {{ trans('quality_assurance.configuration.modal.sla.empty') }}
        </small>
        <sla-affected-assets-section
            v-else-if="selectedSla"
            :assets="selectedSla.coveredAssets || []"
            :heading="trans('quality_assurance.configuration.modal.sla.covered_assets')"
        />
    </div>

    <sla-contract-term-field
        v-if="selectedSla"
        v-model:start="form.term_start"
        v-model:end="form.term_end"
        :end-error="form.errors.term_end"
        :sla-end="selectedSla.endDate"
        :sla-start="selectedSla.startDate"
        :start-error="form.errors.term_start"
    />
</template>

<script setup>
import JetSelect from '@/Jetstream/Select.vue';
import SlaAffectedAssetsSection from '@/Pages/Stakeholders/Maintainers/SlaAffectedAssetsSection.vue';
import SlaContractTermField from '@/Components/SlaContractTermField.vue';
import { trans } from '@/mixins/i18n.js';

defineProps({
    form: {
        type: Object,
        required: true,
    },
    slaOptions: {
        type: Array,
        required: true,
    },
    canManagePreventativeSchedule: {
        type: Boolean,
        required: true,
    },
    selectedSla: {
        type: Object,
        default: null,
    },
});
</script>
